import { render, staticRenderFns } from "./AppointmentParticipant.vue?vue&type=template&id=653467ad&scoped=true&"
import script from "./AppointmentParticipant.ts?vue&type=script&lang=ts&"
export * from "./AppointmentParticipant.ts?vue&type=script&lang=ts&"
import style0 from "./AppointmentParticipant.scss?vue&type=style&index=0&id=653467ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653467ad",
  null
  
)

export default component.exports